<template>
  <div
    id="saved-grocery"
    class="page-content"
  >
    <div class="row">
      <div class="col-12">
        <saved-groceries :refresh-data="refreshSavedGroceries" />
      </div>
      <div class="col-12">
        <saved-grocery-details @saved="needRefreshSavedGroceries" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, nextTick, defineAsyncComponent, ref } from 'vue';
import { useRoute } from 'vue-router';

// User-defined components
import util from '@/Utils/util';

const SavedGroceries = defineAsyncComponent(() => import('./Grocery/SavedGrocery/SavedGroceries.vue') as any);

const SavedGroceryDetails = defineAsyncComponent(() => import('./Grocery/SavedGrocery/SavedGroceryDetails.vue') as any);

const refreshSavedGroceries = ref(false);
const needRefreshSavedGroceries = async () => {
  refreshSavedGroceries.value = true;

  await nextTick();
  refreshSavedGroceries.value = false;
};

onMounted(async () => {
  const route = useRoute();
  const hash = route.hash;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
